import { restClient } from '@/Core'

export const ConfirmAssignmentExecutionTask = async (taskUuid: string, dispatcherComment?: string): Promise<void> => {
    await restClient.post(`/services/executor-assignments/${taskUuid}/confirm-execution`, {
        json: dispatcherComment ? { dispatcherComment } : {},
    })
}
